import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../../lib/api";
import { ICON_MAP } from "../../data/categories";
import { Reveal, SectionHeading } from "../Reveal";

export function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/content/services").then((r) => setServices(r.data || [])).catch(() => {});
  }, []);

  return (
    <section id="services" data-testid="services-section" className="relative overflow-hidden bg-forest-ink py-20 lg:py-28">
      <div className="bg-noise pointer-events-none absolute inset-0" />
      <div
        className="pointer-events-none absolute -top-40 right-0 h-[420px] w-[420px] rounded-full opacity-20"
        style={{ background: "radial-gradient(circle, rgba(212,175,55,0.4) 0%, transparent 65%)" }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          dark
          chapter={["02", "What We Do"]}
          title={
            <>
              Services built around{" "}
              <em className="font-editorial font-medium italic text-gold">one outcome: yours.</em>
            </>
          }
          subtitle="Every engagement starts with your goal and works backwards. No generic packages — a plan built for your timeline, budget, and ambition."
        />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
          {services.map((s, i) => {
            const Icon = ICON_MAP[s.icon] || ICON_MAP.Compass;
            return (
              <Reveal key={s.id || s.slug} delay={(i % 3) * 0.09}>
                <Link
                  to={s.path || "/"}
                  data-testid={`service-card-${s.slug}`}
                  className="group flex h-full flex-col rounded-3xl border border-emerald-100/10 bg-[#0F2B22] p-7 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_24px_60px_rgba(0,0,0,0.35)]"
                >
                  <div className="flex items-start justify-between">
                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/10 text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-forest-deep">
                      <Icon className="h-5 w-5" />
                    </span>
                    <ArrowUpRight className="h-5 w-5 text-emerald-100/25 transition-all duration-300 group-hover:translate-x-0.5 group-hover:text-gold" />
                  </div>
                  <h3 className="mt-6 font-display text-xl font-bold text-bone">{s.title}</h3>
                  <p className="mt-2.5 flex-1 text-sm leading-relaxed text-emerald-100/55">{s.description}</p>
                  <div className="mt-6 flex items-center gap-2 border-t border-emerald-100/10 pt-5">
                    <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-emerald-100/40">Outcome</span>
                    <span className="rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-[11px] font-semibold text-gold-soft">
                      {s.outcome}
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
